import * as React from 'react';

import {preventTracking} from 'common/util/dom';
import {SelectorType} from 'common/query-builder/query-block/constants';
import {ButtonTheme} from 'common/components/button/constants';
import {DateRange} from 'common/widgets/date-range-picker/models/date-range';
import {TimeQueryBlock} from 'common/query-builder/query-block/time-menu/time-query-block';

import {Action, FiltersOperator, QueryBehaviorEntry} from '../types';
import {EntryRowProps} from '../row-types/types';

export function BehaviorRowDateRange(
  props: EntryRowProps<QueryBehaviorEntry> & {
    contextPanelParentElement: HTMLElement;
  },
) {
  /**
   * A funnel based behavior defines the conversion window to be the first date range from the first
   * funnel step, changing the date on subsequent steps has no effect so we hide it
   */
  const hideTimeSelector = props.entry.behavioralFiltersOperator === FiltersOperator.Then && props.index !== 0;

  const onDateRangeChange = (selection: DateRange) => {
    const entry = {
      ...props.entry,
      dateRange: selection.getAttributes(),
    };

    props.updateEntry(Action.Edit, entry);
    props.trackAction(Action.SelectDateRange, entry, (selection as any).props);
  };

  return (
    !hideTimeSelector && (
      <TimeQueryBlock
        elref='behaviorTimeBlock'
        displayContext={props.sectionProps.timeDisplayContext}
        maxDataHistoryDays={props.sectionProps.maxDataHistoryDays}
        leftIcon='calendar'
        selectorType={SelectorType.Button}
        selected={props.entry.dateRange || props.getDefaultDateValue()}
        theme={ButtonTheme.Select}
        projectAsOfDate={props.sectionProps.projectAsOfDate}
        onSelect={onDateRangeChange}
        onTrack={preventTracking}
      />
    )
  );
}
